export const vs2ngaLimitedReleasesListConstants = {
  VS2NGA_LIMITED_RELEASES_LIST_LOADING: "VS2NGA_LIMITED_RELEASES_LIST_LOADING",
  VS2NGA_LIMITED_RELEASES_LIST_SUCCESS: "VS2NGA_LIMITED_RELEASES_LIST_SUCCESS",
  VS2NGA_LIMITED_RELEASES_LIST_FAILURE: "VS2NGA_LIMITED_RELEASES_LIST_FAILURE",
};
